export default __webpack_public_path__ + "static/media/cplusplus.0a81196c.png";